<template>
    <div class="view">
        <div class="joinHearder">
            <div class="driverInfo">
                <div class="driverName">
                    <img :src="driverInfo.avatar" alt="" class="avatar" />
                    <span class="name">{{ driverInfo.name }}</span>
                    <span>{{ driverInfo.mobile }}</span>
                </div>
                <img v-if="joinInfo.join_status == 2" :src="rejectIcon" alt="" class="rejectIcon"/>
            </div>
            <div class="rejectInfo" v-if="joinInfo.join_status == 2">
                <div class="title">审核不通过</div>
                <div class="reamrk">{{ joinInfo.join_remark }}</div>
            </div>
        </div>
        <div class="serviceBox">
            <div class="serviceLi">
                <div class="hearder">
                    <div class="title">
                        <span class="must">*</span>
                        <span>服务项目（多选）</span>
                    </div>
                    <div class="btn"></div>
                </div>
                <div class="typeData">
                    <div :class="['typeLi', {'activeType': item.ischeck}, {'noMargin': (index+1)%4 == 0}]" v-for="(item, index) in types" :key="index" @click="handService(item)">{{ item.title }}</div>
                </div>
            </div>
            <div class="serviceLi">
                <div class="hearder">
                    <div class="title">
                        <span class="must">*</span>
                        <span>常驻区域</span>
                    </div>
                    <div class="cityBtn" @click="addCitys">添加</div>
                </div>
                <div class="cityData">
                    <div class="cityLi" v-for="(item, index) in citys" :key="index">
                        <span class="name">{{ item.pname }}{{ item.cname }}{{ item.aname }}</span>
                        <!-- <van-icon name="clear" color="#666" @click="delCity(index)"/> -->
                    </div>
                </div>
            </div>
            <div class="serviceLi">
                <div class="hearder">
                    <div class="title">
                        <span class="must">*</span>
                        <span>是否承接聚合案件</span>
                    </div>
                    <div class="radioBox">
                        <div class="radio" @click="checkRadio(1)">
                            <img :src="form.is_pingan == 1 ? radio_y : radio_n" alt="" class="icon">
                            <span>是</span>
                        </div>
                        <div class="radio" @click="checkRadio(0)">
                            <img :src="form.is_pingan == 0 ? radio_y : radio_n" alt="" class="icon">
                            <span>否</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uploadBox" v-for="(item, index) in joinUploadData" :key="index">
            <div class="hearder">
                <span>{{ item.name }}</span>
                <span class="tips">（每项最多上传三张）</span>
            </div>
            <div class="uploadData serviceUpload">
                <div class="uploadLi" v-for="(item1, index1) in item.data" :key="index1">
                    <div class="name">
                        <span class="must">*</span>
                        <span>{{ item1.name }}</span>
                    </div>
                    <div class="remark">{{ item1.desc }}</div>
                    <div class="uploadImg">
                        <div :class="['imgLi', {'noMargin': (imgIndex+1)%3 == 0}]" v-for="(img, imgIndex) in item1.img" :key="imgIndex">
                            <img :src="img" alt="" class="img" @click="preImg(img)"/>
                            <div class="deleteIcon" @click.stop="delImg(index, index1, imgIndex)">
                                <van-icon name="cross" color="#fff" size="12px"/>
                            </div>
                        </div>
                        <van-uploader 
                            v-if="item1.img.length < 3"
                            upload-text="点击上传"
                            :after-read="(file) => uploadImg(file, index, index1)"
                            max-count='1' />
                    </div>
                </div>
            </div>
        </div>
        <div class="affirmBtn" @click="submitJoin">提 交</div>
        <!-- 选择服务区域 -->
        <van-popup v-model="cityPicker" round position="bottom" safe-area-inset-bottom>
            <van-picker 
                ref="cityPicker"
                show-toolbar 
                title="服务区域" 
                :columns="cityData"
                value-key="name"
                @confirm='confirmCity'
                @cancel='cityPicker = false'/>
        </van-popup>
        <!-- 提交成功 -->
        <van-dialog 
            v-model="submitSuccess" 
            confirm-button-text='前往下载APP'
            :confirm-button-color='$themeColor'
            @confirm='dowloadAPP'>
            <div class="submitSuccess">
                <img src="@/assets/rescueImgs/success.png" alt=""/>
                <span>提交成功</span>
                <span class="tips">预计1~3个工作日完成审核</span>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import Compressor from 'compressorjs';
import { driverDetail, getRegion, getJoinService, getJoinAttachment, driverJoin, driverJoinInfo } from '@/apis/join'
import { uploadFileOss, ossParams } from '@/apis/rescue';
import { ImagePreview } from 'vant';
export default {
    data(){
        return {
            company: '',
            driverInfo: '',
            joinInfo: '',   //已加盟师傅加盟信息详情
            ossInfo: '',
            radio_n: require('@/assets/join/radio_n.png'),
            radio_y: require('@/assets/join/radio_y.png'),
            rejectIcon: require('@/assets/join/rejectIcon.png'),
            // 可加盟项目
            types: [],
            cityData: [],         //所有区域
            citys: [],          //选择的区域
            fieldNames: {
                text: 'name',
                value: 'id',
                children: 'sub',
            },
            joinUploadData: [],
            form: {
                service: '',           //服务
                is_pingan: 0,       //是否承接平安订单
            },
            cityPicker: false,
            timer: null,
            submitSuccess: false,
            images: {}
        }
    },
    mounted(){
        let e = this.$route.query.e
        if(e){
            let info = this.$xorEncrypt(e)
            info = JSON.parse(info)
            this.company = info.company
            let nowTime = new Date().getTime();
            if(nowTime - info.time > 12*60*60*1000){
                this.toRegister()
            }else{
                this.driverId = info.id
                this.getService()
                this.getDetail()
                this.getOSSParam()
                this.getRegionData()
            }
        }else{
            this.toRegister()
        }
    },
    methods: {
        // 回注册页
        toRegister(){
            this.$notify({
                type: 'danger',
                message: '验证信息过期，请重新获取验证码！'
            })
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('driverId');
            this.$router.replace(`/register?s=${this.company}`);
        },
        // 师傅详情
        getDetail(){
            let params = {
                id: this.driverId
            }
            driverDetail(params).then((res)=>{
                let info = res.data.data
                this.driverInfo = info
                if(info.is_join == 1){
                    this.getDriverJoinInfo()
                }
            })
        },
        // 师傅加盟详情
        getDriverJoinInfo(){
            driverJoinInfo().then((res)=>{
                console.log('师傅加盟详情', res.data.data)
                let info = res.data.data
                this.joinInfo = info
                this.form.is_pingan = info.is_pingan
                this.form.service = info.type
                let types = info.type.split(',')
                let attachment = JSON.parse(info.attachment)
                for(let i=0; i<types.length; i++){
                    for(let j=0; j<this.types.length; j++){
                        if(types[i] == this.types[j].type){
                            this.types[j].ischeck = true;
                            break;
                        }
                    }
                }
                for(let a=0; a<attachment.length; a++){
                    let info = attachment[a]
                    for(let key in info){
                        if(!this.images.hasOwnProperty(info[key])){
                            this.images[key] = {}
                        }
                        for(let k=0; k<info[key].length; k++){
                            let name = info[key][k].name
                            let picture = info[key][k].picture
                            this.images[key][name] = picture.split(',')
                        }
                    }
                }
                this.getJoinUploadInfo()
                // 区域
                if(info.region){
                    let obj = {
                        pname: '',
                        pid: '',
                        cname: '',
                        cid: '',
                        aname: '',
                        aid: '',
                    }
                    this.initCityName(obj, 1, this.cityData)
                    this.citys = [obj]
                }
            })
        },
        initCityName(obj, index, citys){
            let region = this.joinInfo.region
            for(let c=0; c<citys.length; c++){
                let cityInfo = citys[c]
                if(index == 1 && cityInfo.name == region.province){
                    obj.pname = cityInfo.name
                    obj.pid = cityInfo.id
                    this.initCityName(obj, ++index, cityInfo.sub)
                }else if(index == 2 && cityInfo.name == region.city){
                    obj.cname = cityInfo.name
                    obj.cid = cityInfo.id
                    this.initCityName(obj, ++index, cityInfo.sub)
                }else if(index == 3 && cityInfo.name == region.area){
                    obj.aname = cityInfo.name
                    obj.aid = cityInfo.id
                }
            }
        },
        // oss参数获取
        getOSSParam() {
            ossParams().then((res)=>{
                this.ossInfo = res.data.data;
            })
        },
        getRegionData(){
            let params = {
                type: 'tree',
                level: '3'
            }
            getRegion(params).then((res)=>{
                let data = res.data.data
                this.cityData = data
                this.initCityData(this.cityData)
            })
        },
        initCityData(citys){
            for(let i=0; i<citys.length; i++){
                if(citys[i].sub && citys[i].sub.length){
                    citys[i].children = citys[i].sub
                    this.initCityData(citys[i].sub)
                }
            }
        },
        getService(){
            getJoinService().then((res)=>{
                let data = res.data.data
                data.forEach((e)=>{
                    e.ischeck = false
                })
                this.types = data
            })
        },
        handService(e){
            e.ischeck = !e.ischeck
            let types = []
            for(let i=0; i<this.types.length; i++){
                let e = this.types[i]
                if(e.ischeck){
                    types.push(e.type)
                }
            }
            this.form.service = types.toString()
            this.getJoinUploadInfo()
        },
        // 获取加盟资料
        getJoinUploadInfo(){
            clearTimeout(this.timer);
            this.timer = setTimeout(()=>{
                if(!this.form.service){
                    this.joinUploadData = []
                    return
                }
                let params = {
                    type: this.form.service,
                    is_pingan: this.form.is_pingan
                }
                getJoinAttachment(params).then((res)=>{
                    let joinUploadData = res.data.data
                    for(let j=0; j<joinUploadData.length; j++){
                        for(let k=0; k<joinUploadData[j].data.length; k++){
                            joinUploadData[j].data[k].img = []
                        }
                    }
                    this.joinUploadData = joinUploadData
					this.initImages()
                })
            }, 500)
        },
        initImages(){
            for(let i=0; i<this.joinUploadData.length; i++){
                let info = this.joinUploadData[i]
                let infoImgs = this.images[info.id]
                if(infoImgs){
                    for(let j=0; j<info.data.length; j++){
                        let name = info.data[j].name
                        if(infoImgs[name]){
                            info.data[j].img = infoImgs[name]
                        }
                    }
                }
            }
        },
        checkRadio(e){
            if(this.form.is_pingan == e) return
            this.form.is_pingan = e
            this.getJoinUploadInfo()
        },
        // 添加服务区域
        addCitys(){
            this.cityPicker = true
        },
        // 确认服务区域
        confirmCity(e, index){
            this.citys = []
            let pInfo = this.cityData[index[0]]
            let cInfo = pInfo.children ? pInfo.children[index[1]] : ''
            let aInfo = cInfo.children ? cInfo.children[index[2]] : ''
            let info = {
                pid: pInfo.id,
                pname: pInfo.name,
                cid: cInfo.id,
                cname: cInfo.name,
                aid: aInfo.id,
                aname: aInfo.name,
            }
            this.citys = [info]
            this.cityPicker = false
        },
        // 删除区域
        delCity(index){
            this.citys.splice(index, 1)
        },
        // 上传资料
        uploadImg(file, index, index1){
            let that = this;
            new Compressor(file.file, {
                quality: 0.2,
                success(result) {
                    let uploadUrl = that.ossInfo.host;
                    let fileName = file.file.name.substring(file.file.name.lastIndexOf(".") + 1, file.file.name.length);
                    let keyInfo = that.ossInfo.dir + '/' + that.randomString(32) + '.' + fileName;
                    let formData = new FormData();
                    formData.append('Filename', 'upload');
                    formData.append('name', 'upload');
                    formData.append('key', keyInfo);
                    formData.append('policy', that.ossInfo.policy);
                    formData.append('OSSAccessKeyId', that.ossInfo.accessid);
                    formData.append('success_action_status', 200);
                    formData.append('signature', that.ossInfo.signature);
                    formData.append('file', result);
                    uploadFileOss(uploadUrl, formData).then((res)=>{
                        let url = `${uploadUrl}/${keyInfo}`
                        let info = that.joinUploadData[index]
                        let id = info.id
                        let name = info.data[index1].name
                        if(that.images.hasOwnProperty(id)){
                            if(that.images[id].hasOwnProperty(name)){
                                that.images[id][name].push(url)
                            }else{
                                that.images[id][name] = [url]
                            }
                        }else{
                            that.images[id] = {}
                            that.images[id][name] = [url]
                        }
                        that.initImages()
                    }).catch((e)=>{
                        this.$toast('上传失败')
                    })
                }
            })
        },
        randomString(len) {
            len = len || 32;
            let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
            let maxPos = chars.length;
            let pwd = '';
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },
        delImg(index, index1, imgIndex){
            console.log(index, index1)
            let info = this.joinUploadData[index]
            let id = info.id
            let name = info.data[index1].name
            if(this.images.hasOwnProperty(id)){
                if(this.images[id].hasOwnProperty(name)){
                    this.images[id][name].splice(imgIndex, 1)
                    this.initImages()
                }
            }
        },
        // 预览图片
        preImg(url){
            ImagePreview([url]);
        },
        submitJoin(){
            if(!this.form.service){
                this.$notify({
                    type: 'danger',
                    message: '请选择加盟项目！'
                })
                return
            }
            if(!this.citys.length){
                this.$notify({
                    type: 'danger',
                    message: '请选择常驻区域！'
                })
                return
            }
            if(!this.joinUploadData.length){
                this.$notify({
                    type: 'danger',
                    message: '认证资料异常，请联系负责人！'
                })
                return
            }
            let joinUploadData = this.joinUploadData
            let attachment = []
            for(let j=0; j<joinUploadData.length; j++){
                let id = joinUploadData[j].id
                let obj = {}
                for(let k=0; k<joinUploadData[j].data.length; k++){
                    let authInfo = joinUploadData[j].data[k]
                    if(!authInfo.img.length){
                        this.$notify({
                            type: 'danger',
                            message: `请上传${authInfo.name}资料！`
                        })
                        return
                    }else{
                        if(obj.hasOwnProperty(id)){
                            obj[id].push({name: authInfo.name, picture: authInfo.img.toString()})
                        }else{
                            obj[id] = [{name: authInfo.name, picture: authInfo.img.toString()}]
                        }
                    }
                }
                attachment.push(obj)
            }
            let region = {}, pid, cid, aid;
            pid = this.citys[0].pid
            cid = this.citys[0].cid
            aid = this.citys[0].aid
            region[pid] = {}
            region[pid][cid] = [aid]
            console.log(region)
            console.log(attachment)
            let params = {
                type: this.form.service,
                is_pingan: this.form.is_pingan,
                region: JSON.stringify(region),
                attachment: JSON.stringify(attachment)
            }
            driverJoin(params).then((res)=>{
                console.log(res, '提交认证')
                let data = res.data
                if(data.code == 4000){
                    this.$notify({
                        type: 'danger',
                        message: '登录异常，请重新获取验证码登录！'
                    })
                    this.$router.go(-1)
                    return
                }
                if(data.code == 1){
                    this.submitSuccess = true
                }else{
                    this.$notify({
                        type: 'danger',
                        message: data.info || data.data
                    })
                }
            })
        },
        dowloadAPP(){
            this.$router.replace(`/app?source=${this.company}&type=0`);
        }
    }
}
</script>

<style lang="scss">
    .serviceUpload{
        .van-uploader__preview, .van-uploader__upload {
            width: 93px;
            height: 70px;
            margin-right: 12px;
            border-radius: 5px;
            background: #CECECE;
            margin: 0;
            .van-image{
                width: 93px;
                height: 70px;
                margin-right: 12px;
                border-radius: 5px;
                background: #CECECE;
            }
            .van-uploader__upload-icon, .van-uploader__upload-text{
                color: #666;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .view{
        min-height: 100vh;
        background: #F2F4F5;
        padding: 12px;
        box-sizing: border-box;
        .joinHearder{
            background: #FFFFFF;
            border-radius: 10px;
            margin-bottom: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 12px;
            box-sizing: border-box;
            .driverInfo{
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 16px;
                color: #333333;
                .driverName{
                    display: flex;
                    align-items: center;
                    .avatar{
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                    }
                    .name{
                        margin: 0 8px 0 12px;
                    }
                }
                .rejectIcon{
                    width: 54px;
                    height: 54px;
                }
            }
            .rejectInfo{
                width: 320px;
                background: #FFF3F3;
                border-radius: 10px;
                padding: 12px;
                box-sizing: border-box;
                font-size: 13px;
                color: #F01C1C;
                margin-top: 12px;
                .title{
                    line-height: 18px;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                .reamrk{
                    line-height: 18px;
                }
            }
        }
        .serviceBox{
            background: #FFFFFF;
            border-radius: 10px;
            padding: 12px;
            box-sizing: border-box;
            margin-bottom: 12px;
            .serviceLi{
                margin-bottom: 20px;
                .hearder{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    .title{
                        font-weight: 600;
                        font-size: 14px;
                        color: #333333;
                        .must{
                            color: #F01C1C;
                        }
                    }
                    .cityBtn{
                        font-size: 14px;
                        color: #F7AB00;
                    }
                }
                .typeData{
                    display: flex;
                    flex-wrap: wrap;
                    .typeLi{
                        width: 73px;
                        height: 32px;
                        margin-right: 10px;
                        border-radius: 50px;
                        border: 1px solid #CCCCCC;
                        margin-bottom: 12px;
                        text-align: center;
                        line-height: 32px;
                        font-weight: 500;
                        font-size: 13px;
                        color: #666666;
                        box-sizing: border-box;
                    }
                    .activeType{
                        border: none;
                        background: var(--theme-color);
                        color: var(--theme-btn);
                    }
                    .noMargin{
                        margin-right: 0;
                    }
                }
                .cityData{
                    display: flex;
                    flex-wrap: wrap;
                    .cityLi{
                        background: #F7F7F7;
                        border-radius: 28px;
                        margin-right: 20px;
                        font-weight: 400;
                        font-size: 13px;
                        color: #666666;
                        padding: 8px;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        margin-bottom: 12px;
                        .name{
                            margin-right: 8px;
                        }
                    }
                }
                .radioBox{
                    display: flex;
                    align-items: center;
                    .radio{
                        margin-left: 26px;
                        font-size: 14px;
                        color: #333333;
                        display: flex;
                        align-items: center;
                        .icon{
                            width: 16px;
                            height: 16px;
                            margin-right: 8px;
                        }
                    }
                }
            }
        }
        .uploadBox{
            background: #FFFFFF;
            border-radius: 10px;
            padding: 12px;
            box-sizing: border-box;
            margin-bottom: 12px;
            .hearder{
                display: flex;
                align-items: center;
                font-weight: 600;
                font-size: 14px;
                color: #333333;
                .tips{
                    font-weight: 400;
                    font-size: 12px;
                    color: #999999;
                    margin-left: 6px;
                }
            }
            .uploadData{
                .uploadLi{
                    margin-top: 12px;
                    background: #F7F7F7;
                    border-radius: 5px;
                    padding: 12px;
                    box-sizing: border-box;
                    .name{
                        font-weight: 600;
                        font-size: 16px;
                        color: #333333;
                        margin-bottom: 6px;
                        .must{
                            color: #F01C1C;
                        }
                    }
                    .remark{
                        line-height: 18px;
                        font-weight: 400;
                        font-size: 13px;
                        color: #999999;
                    }
                    .uploadImg{
                        display: flex;
                        margin-top: 12px;
                        .imgLi{
                            width: 93px;
                            height: 70px;
                            margin-right: 12px;
                            border-radius: 5px;
                            position: relative;
                            .img{
                                width: 100%;
                                height: 100%;
                                border-radius: 5px;
                            }
                            .deleteIcon{
                                width: 16px;
                                height: 16px;
                                background: rgba(0,0,0,0.67);
                                border-radius: 0px 5px 0px 5px;
                                position: absolute;
                                right: 0;
                                top: 0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                        .noMargin{
                            margin-right: 0;
                        }
                    }
                }
            }
        }
        .affirmBtn{
            width: 351px;
            height: 40px;
            background: var(--theme-color);
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 16px;
            color: var(--theme-btn);
            margin: 40px auto 0;
        }
        .submitSuccess{
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
                width: 36px;
                height: 36px;
                margin-top: 36px;
            }
            span{
                line-height: 22px;
                font-weight: 600;
                font-size: 16px;
                color: #000000;
                margin: 10px auto 4px;
            }
            .tips{
                line-height: 19px;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                margin: 0 auto 27px;
            }
        }
    }
</style>